import { render, staticRenderFns } from "./MenusEdit.vue?vue&type=template&id=17be7d39"
import script from "./MenusEdit.vue?vue&type=script&lang=js"
export * from "./MenusEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports